import { ApolloClient, InMemoryCache, from } from '@apollo/client';
import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';

import { errorLink } from './links/errorLink';
import { httpLink } from './links/httpLink';
import { retryLink } from './links/retryLink';
import { scalarsLink } from './links/scalarsLink';

import { urlBuilder } from '../utils/urlBuilder';

if (process.env.NODE_ENV !== 'production') {
  loadDevMessages();
  loadErrorMessages();
}

export const client = new ApolloClient({
  link: from([retryLink, errorLink, scalarsLink, httpLink(urlBuilder.graphQL(), {})]),
  cache: new InMemoryCache(),
  connectToDevTools: true,
  defaultOptions: {
    query: {
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
    },
    mutate: {
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
    },
    watchQuery: {
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    },
  },
});
